import { UnifiedResponse } from "../../../models/Response/unifiedResponse";
import errorModal from "../../../services/errorModal.service";
import { responsibleGamingApi } from "../api/responsibleGaming.api";
import {
  RetrieveUserDepositLimitRequest,
  TakeABreakRequest,
  UndoUserDepositLimitRequest,
  UserPersistDepositLimitRequest,
  UserSelfExcludeRequest,
} from "../models/request";
import {
  RetrieveUserDepositLimitResponse,
  UserPersistDepositLimitResponse,
} from "../models/response";

export const responsibleGamingService = {
  retrieveDepositLimit: async (data: RetrieveUserDepositLimitRequest): Promise<UnifiedResponse<RetrieveUserDepositLimitResponse>> => {
    var response = await responsibleGamingApi.retrieveDepositLimit(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  persistDepositLimit: async (
    data: UserPersistDepositLimitRequest
  ): Promise<UnifiedResponse<UserPersistDepositLimitResponse>> => {
    var response = await responsibleGamingApi.persistDepositLimit(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  undoDepositLimit: async (
    data: UndoUserDepositLimitRequest
  ): Promise<UnifiedResponse<any>> => {
    var response = await responsibleGamingApi.undoDepositLimit(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  takeABreak: async (
    data: TakeABreakRequest
  ): Promise<UnifiedResponse<any>> => {
    var response = await responsibleGamingApi.takeABreak(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },

  selfExclude: async (
    data: UserSelfExcludeRequest
  ): Promise<UnifiedResponse<any>> => {
    var response = await responsibleGamingApi.selfExclude(data);
    if (!response.isSuccess) {
      errorModal.showErrorModal(response.statusCode, response.message);
    }
    return response;
  },
};
